// Simple solution from https://markus.oberlehner.net/blog/simple-solution-to-prevent-body-scrolling-on-ios/
// that works on iOS

// FIXME: we already use body-scroll-lock package
let scrollPosition = 0;

export default {
  enable() {
    if (!process.client) return;
    const bodyElement = document?.querySelector('body') as HTMLBodyElement;
    scrollPosition = window.pageYOffset;
    if (bodyElement.style.overflow === 'hidden') return;

    bodyElement.style.overflow = 'hidden';
    bodyElement.style.position = 'fixed';
    bodyElement.style.top = `-${scrollPosition}px`;
    bodyElement.style.width = '100%';
  },

  disable() {
    if (!process.client) return;
    const bodyElement = document?.querySelector('body') as HTMLBodyElement;
    if (!bodyElement.style.overflow) return;

    bodyElement.style.removeProperty('overflow');
    bodyElement.style.removeProperty('position');
    bodyElement.style.removeProperty('top');
    bodyElement.style.removeProperty('width');
    window.scrollTo(0, scrollPosition);
  },
};
